// extracted by mini-css-extract-plugin
export default {"container":"vn-z","bubbleNav":"wn-z","graphic":"xn-z","contact":"yn-z"};